export { default as AdvDetailed } from './AdvDetailed'
